import { render } from "./LeistungsberechnungWechselstrom.vue?vue&type=template&id=2b28ff8c"
import script from "./LeistungsberechnungWechselstrom.vue?vue&type=script&lang=js"
export * from "./LeistungsberechnungWechselstrom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__